module.exports = __webpack_public_path__ + "static/media/schema_5d34.json"